function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M43.1167 33.2289H37.6936V8.65662C37.6936 6.65441 36.2341 5.02459 34.4398 5.02459H26.8475V9.7253H33.3552V37.9296H43.1167C43.7159 37.9296 44.2013 37.4037 44.2013 36.7544V34.404C44.2013 33.7548 43.7159 33.2289 43.1167 33.2289ZM21.983 0.398056L8.96773 4.05139C8.00175 4.32242 7.32455 5.29635 7.32455 6.41423V33.2289H1.9015C1.30226 33.2289 0.816895 33.7548 0.816895 34.404V36.7544C0.816895 37.4037 1.30226 37.9296 1.9015 37.9296H24.6783V2.7609C24.6783 1.17588 23.3524 0.0131848 21.983 0.398056V0.398056ZM18.7129 21.4771C17.8148 21.4771 17.086 20.4246 17.086 19.1267C17.086 17.8289 17.8148 16.7764 18.7129 16.7764C19.6111 16.7764 20.3399 17.8289 20.3399 19.1267C20.3399 20.4246 19.6111 21.4771 18.7129 21.4771Z",
  fill: "white"
});

function SvgHallway(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 38,
    viewBox: "0 0 45 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHallway);
export default __webpack_public_path__ + "static/media/hallway.7721d27e645fd758528c541b0df73bbc.svg";
export { ForwardRef as ReactComponent };